<script>
import api from "../../services/api";
import Loader from "../../components/loader";

export default {
  props: {
    resourceName: {
      type: String,
      required: true
    },
    resource: {
      type: Object,
      required: true
    }
  },
    components: {
      Loader
    },
    data() {
        return {
          isSubmitting: false,
          localResourceNamePlur: this.resourceName + 's',
        };
    },
    computed: {
    },
    methods: {
      async submitForm() {
        this.isSubmitting = true;

        api.save(this.localResourceNamePlur, this.resource)
            .then((response) => {
              if (response.status !== 200)
                this.$emit('error');
              else
                this.$emit('submitted');

              this.isSubmitting = false;

            })
            .catch(() => {
              this.$emit('error');
              this.isSubmitting = false;
            });
      },
    },
    mounted() {
    }
};
</script>

<template>
  <Loader :loading="isSubmitting">
  <b-container>
    <slot />
  </b-container>
  <b-card-footer>
    <b-row>
      <b-col>
        <div class="text-right">
          <b-button variant="primary" class="text-capitalize" @click="submitForm">{{ $t('general.save') }}</b-button>
          <b-button variant="secondary" class="ms-2 text-capitalize" @click="$emit('cancel')">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-card-footer>
</Loader>
</template>
